import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import Search from "../../../../components/shared/Search";
import { OwcButton } from "@one/react";
import { BookingAccessControlContext } from "../BookingAccessControlContext";

export const TopBarStyle = styled.div`
  display: flex;
  justify-content: space-between;
`;

const AssignGroupTopBar = ({
  setSearchGroup,
  groupContext,
  searchLabel,
  searchSize,
  buttonText = "Assign group",
}) => {
  const { setDialogOpen, setIsEditMode } = useContext(groupContext);
  const { groupSearchEvent } = useContext(BookingAccessControlContext);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    setSearchGroup(searchQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  useEffect(() => {
    setSearchQuery(groupSearchEvent?.query || "");
  }, [groupSearchEvent?.version, groupSearchEvent?.query]);

  return (
    <TopBarStyle>
      <Search
        setQuery={setSearchQuery}
        label={searchLabel}
        size={searchSize}
        externalQuery={searchQuery}
      />
      <OwcButton
        variant="primary"
        key="create-reason-button"
        onClick={() => {
          setIsEditMode(false);
          setDialogOpen(true);
        }}
      >
        {buttonText}
      </OwcButton>
    </TopBarStyle>
  );
};

export default AssignGroupTopBar;
